import React from "react";
import { Container, Row, Col, Card, Button,ListGroup  } from "react-bootstrap";
import {
  BagCheck,
  CardChecklist,
  Star,
  CreditCard,
  GeoAlt,
  Gear,
  InfoCircle,
  House,
  Gift,
  BoxArrowRight,
  PersonCircle,
  Telephone,
} from "react-bootstrap-icons";

export default function Profile() {
  return (
     <Container fluid >
      <Col md={6} lg={4}>
        {/* User Info Card */}
        <Card className="shadow-sm mb-4 text-center border-0">
          <Card.Body>
            <PersonCircle size={80} className="text-secondary mb-3" />
            <Card.Title className="fw-bold">John Doe</Card.Title>
            <Card.Text className="text-muted mb-1">
              <Telephone className="me-2" /> +91 9876543210
            </Card.Text>
            <Card.Text className="text-muted">
              <GeoAlt className="me-2" /> New Delhi, India
            </Card.Text>
          </Card.Body>
        </Card>

        {/* Menu Options */}
        <ListGroup variant="flush" className="shadow-sm rounded bg-white">
          <ListGroup.Item action className="d-flex align-items-center">
            <BagCheck className="me-3 text-primary" /> My Orders
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center">
            <CardChecklist className="me-3 text-success" /> My Plan
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center">
            <Star className="me-3 text-warning" /> Plus Membership
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center">
            <Star className="me-3 text-info" /> My Rating
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center">
            <CreditCard className="me-3 text-danger" /> Manage Payment Method
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center">
            <GeoAlt className="me-3 text-secondary" /> Manage Address
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center">
            <Gear className="me-3 text-dark" /> Settings
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center">
            <House className="me-3 text-primary" /> About House Clean
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center">
            <Gift className="me-3 text-success" /> Refer & Earn
          </ListGroup.Item>
          <ListGroup.Item action className="d-flex align-items-center text-danger fw-bold">
            <BoxArrowRight className="me-3" /> Logout
          </ListGroup.Item>
        </ListGroup>
      </Col>
    </Container>
  )
}
